// extracted by mini-css-extract-plugin
export default {"disabled":"MainPage_disabled__S6JDy","content":"MainPage_content__ymv5Q","glitch":"MainPage_glitch__uNANX","glitch2":"MainPage_glitch2__x8CvJ"};